import React from 'react'

import { Heading, Pagination } from 'core'
import { labelForFilter } from 'event-taxonomy'

import EventsFilters from './EventsFilters'
import EventsIndexView from './EventsIndexView'
import EventsViewToggle from './EventsViewToggle'
import EventsCalendarView from './calendar/EventsCalendarView'

import css from './style.scss'

const UpcomingEventsSection = ({
  events,
  eventsPages,
  calendarEvents,
  activeType,
  activeView,
  month,
  bounds,
  query,
  onDropdownChange,
  onMonthChange
}) => {
  const emptyLabel = activeType ? labelForFilter(activeType) : 'events'

  // Registration deadlines are excluded from `events` (the list) but always
  // present in `calendarEvents` — the calendar is the one place they still
  // show, alongside live events on one timeline.
  const content = activeView === 'calendar'
    ? (
      <EventsCalendarView
        month={month}
        bounds={bounds}
        events={calendarEvents}
        onMonthChange={onMonthChange}
      />
      )
    : (
      <div>
        <EventsIndexView events={events} emptyLabel={emptyLabel} />
        {eventsPages > 1 && <Pagination pages={eventsPages} pageParamKey='eventsPage' />}
      </div>
      )

  return (
    <section aria-labelledby='upcoming-events-heading'>
      <div className={css.sectionHeader}>
        <Heading id='upcoming-events-heading' size='h3' as='h1' weight='semibold' noMargin>
          Upcoming Live Events
        </Heading>
        <EventsViewToggle activeView={activeView} query={query} />
      </div>

      <EventsFilters
        activeType={activeType}
        query={query}
        onDropdownChange={onDropdownChange}
      />

      {content}
    </section>
  )
}

UpcomingEventsSection.propTypes = {
  events: React.PropTypes.array.isRequired,
  eventsPages: React.PropTypes.number.isRequired,
  calendarEvents: React.PropTypes.array.isRequired,
  activeType: React.PropTypes.string,
  activeView: React.PropTypes.oneOf(['index', 'calendar']).isRequired,
  month: React.PropTypes.object,
  bounds: React.PropTypes.object,
  query: React.PropTypes.object,
  onDropdownChange: React.PropTypes.func.isRequired,
  onMonthChange: React.PropTypes.func.isRequired
}

export default UpcomingEventsSection
